import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pipe_hard_management",
  "use": "icon-pipe_hard_management-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pipe_hard_management\"><path d=\"M896 960h-128c-35.2 0-64-28.8-64-64v-32H544c-88 0-160-72-160-160V496h-64v16c0 35.2-28.8 64-64 64H128c-35.2 0-64-28.8-64-64V128c0-35.2 28.8-64 64-64h128c35.2 0 64 28.8 64 64v48h160c88 0 160 72 160 160v208h64v-32c0-35.2 28.8-64 64-64h128c35.2 0 64 28.8 64 64v384c0 35.2-28.8 64-64 64zM256 144c0-9.6-6.4-16-16-16H144c-9.6 0-16 6.4-16 16v352c0 9.6 6.4 16 16 16h96c9.6 0 16-6.4 16-16V144z m448 464h-96c-17.6 0-32-14.4-32-32V336c0-52.8-43.2-96-96-96H320v192h96c9.6 0 17.6 3.2 22.4 9.6 6.4 6.4 9.6 14.4 9.6 22.4v240c0 52.8 43.2 96 96 96h160V608z m192-80c0-9.6-6.4-16-16-16h-96c-9.6 0-16 6.4-16 16v352c0 9.6 6.4 16 16 16h96c9.6 0 16-6.4 16-16V528z\" fill=\"#ffffff\" p-id=\"5890\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pipe_hard_management.svg
// module id = ED3R
// module chunks = 39